import { withKeys as _withKeys, vModelText as _vModelText, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ba30de7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name", "type"]
const _hoisted_2 = { class: "CookiesInputPlaceholder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.AutoHeight(this))),
    style: {"width":"calc(100% - 3.4em)"},
    class: _normalizeClass(["CookiesInput P-Rel W-100",  [_ctx.ErrorData && ' ErrorBorder ', _ctx.Disabled && ' Disabled '] ])
  }, [
    _withDirectives(_createElementVNode("textarea", {
      onKeypress: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.HandleEnter($event)), ["enter"])),
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changed', _ctx.MEMRead(_ctx.Res)))),
      class: "CookiesCommentBox W-100",
      style: _normalizeStyle(_ctx.CustomStyle),
      name: _ctx.Name !== '' ? _ctx.Name : _ctx.Placeholder,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.$store.state.CookiesMemory[_ctx.Res ? _ctx.Res : 'undefined']) = $event)),
      type: _ctx.type,
      autocomplete: "off"
    }, null, 44, _hoisted_1), [
      [_vModelText, _ctx.$store.state.CookiesMemory[_ctx.Res ? _ctx.Res : 'undefined']]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "M-Auto",
        style: _normalizeStyle((_ctx.MEMRead(_ctx.Res) === '' || !_ctx.MEMRead(_ctx.Res)) ? 'margin-inline-start: 1.25em; margin-top: 1em' : 'margin-inline-start: 0.9em; margin-top: 0.2em; font-size: 0.75em; filter: blur(0.6px)')
      }, _toDisplayString(_ctx.Placeholder), 5)
    ])
  ], 34))
}